module.exports = __webpack_public_path__ + "step1_C2P_aoyama_bridal.123f6bc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step1_C2P_aoyama_bridal.jpg
// module id = xzgm
// module chunks = 0